var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file"},[_c('a',{staticClass:"file__btn",attrs:{"href":_vm.url,"target":_vm.target}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"size":"2x"}}),_vm._v(" "+_vm._s(_vm.heading)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }